import { ArrowRight, Sun, MapPin } from "lucide-react";
import { COMPANY, HERO_BG } from "@/data/site";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_BG}
          alt="Sun flare cinematic"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050B14] via-[#050B14]/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050B14]/40 via-transparent to-[#050B14]" />
      </div>

      {/* Decorative sun ring */}
      <div className="absolute right-[-10%] top-[20%] h-[500px] w-[500px] sun-ring -z-0" />

      <div className="container-x relative z-10 pt-32 pb-20 md:pt-40">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-8">
            <Sun className="h-4 w-4 text-[#FFC857]" />
            <span className="text-xs uppercase tracking-[0.25em] text-[#A0ABC0]">
              Bangalore · Karnataka
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-serif font-light text-white text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] tracking-tight"
          >
            Sun-Powered.
            <br />
            <span className="text-[#FFC857] italic font-medium">
              Future-Proofed.
            </span>
          </h1>

          <p
            data-testid="hero-subline"
            className="mt-8 text-base md:text-lg text-[#A0ABC0] max-w-2xl leading-relaxed font-light"
          >
            {COMPANY.subline}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-quote"
              onClick={() => go("enquiry")}
              className="btn-gold"
            >
              Get Free Quote <ArrowRight className="h-4 w-4" />
            </button>
            <button
              data-testid="hero-cta-explore"
              onClick={() => go("why")}
              className="btn-outline-gold"
            >
              Why Choose Jashvi
            </button>
          </div>

          <div className="mt-14 flex items-center gap-3 text-sm text-[#A0ABC0]">
            <MapPin className="h-4 w-4 text-[#FFC857]" />
            <span className="font-light tracking-wide">
              Serving residential, commercial & industrial rooftops —{" "}
              <span className="text-white">All over Karnataka</span>
            </span>
          </div>
        </div>
      </div>

      {/* scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-[#A0ABC0]">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <div className="h-10 w-px bg-gradient-to-b from-[#FFC857] to-transparent animate-pulse" />
      </div>
    </section>
  );
}
